import React, { useEffect } from "react";
import { NavLink } from "react-router-dom";
import "aos/dist/aos.css";
import Aos from "aos";
import MenuIcon from "@mui/icons-material/Menu";
import { IconButton } from "@mui/material";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import {
  SideBarCalendar,
  SideBarBookingview,
  SideBarCustomers,
  SideBarStaff,
  SideBarServices,
  SideBarDynamicServices,
  SideBarProducts,
  SideBarBusinesses,
  SideBarBusinessDept,
  SideBarBusinessUser,
  SideBarBusinessTeam,
  SideBarWaitinglist,
  SideBarFinancials,
  SideBarAnalytics,
  SideBarMarketing,
  SideBarProfile,
} from "../Assets/svgs";

const SideBarItem = ({
  handleMouseEnter,
  handleMouseLeave,
  isActiveLink,
  isExpanded,
  location,
  setIsExpanded,
  setIsActiveLink,
  children,
  extractedPart,
  permission,
}) => {
  const history = useHistory();
  useEffect(() => {
    setTimeout(function () {
      // setIsExpanded(true)
    }, 6000);
    Aos.init({
      offset: -10000,
      duration: 2000,
    });
  }, []);

  return (
    <div className="overflow_stop_sll_pages">
      <IconButton
        className="side_menu_btn"
        sx={{ p: 0.5, position: "absolute", top: 3, left: 50 }}
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <MenuIcon sx={{ color: "#fff" }} />
      </IconButton>
      <div className="d-flex">
        <div
          className={`d-xl-block side_nav_main_1 ${
            isExpanded ? "expanded" : ""
          }`}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <div className="col-md-12 height_fiz_menu">
            <NavLink
              to="/calendar"
              isActive={(match) => {
                if (
                  match?.isExact ||
                  (location &&
                    (location.pathname.includes("calendar") ||
                      location.pathname.includes("/scheduler/create_booking") ||
                      location.pathname.includes("/scheduler/create_event") ||
                      location.pathname.includes("calendar") ||
                      location.pathname.includes(
                        "/scheduler/create_timeblock"
                      ) ||
                      location.pathname.includes("/scheduler/create_break")))
                ) {
                  setIsActiveLink(1);
                }
              }}
            >
              <div
                className={`py-1 mb-3 ${
                  isActiveLink === 1 ? "inv_active_menu" : "inv_inactive_menu"
                } ${
                  isExpanded
                    ? "ms-2 py-0 mt-3 d-flex"
                    : "ms-1 sidebar-item d-flex  mt-3"
                }`}
              >
                <SideBarCalendar isActiveLink={isActiveLink} />
                {isExpanded ? (
                  <div data-aos="fade-in" className="sidebar-title">
                    Calendar{" "}
                  </div>
                ) : null}
              </div>
            </NavLink>
          </div>
          <div className="col-md-12 height_fiz_menu">
            <NavLink
              to="/all-listing"
              isActive={(match) => {
                if (
                  match?.isExact ||
                  (location && location.pathname.includes("all-listing"))
                ) {
                  setIsActiveLink(2);
                }
              }}
            >
              <div
                className={`py-1 mb-3  ${
                  isActiveLink === 2 ? "inv_active_menu" : "inv_inactive_menu"
                } ${
                  isExpanded ? "ms-2 py-0 d-flex" : "ms-1 sidebar-item d-flex "
                }`}
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.33333 4H4.88889C4.39797 4 4 4.39797 4 4.88889V9.33333C4 9.82425 4.39797 10.2222 4.88889 10.2222H9.33333C9.82425 10.2222 10.2222 9.82425 10.2222 9.33333V4.88889C10.2222 4.39797 9.82425 4 9.33333 4Z"
                    stroke={isActiveLink === 2 ? "#FFFFFF" : "#FFD705"}
                    // fill={isActiveLink === 2 ? "white" : "#FFD705"}
                    stroke-width="1.25"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M9.33333 13.7778H4.88889C4.39797 13.7778 4 14.1758 4 14.6667V19.1112C4 19.6021 4.39797 20.0001 4.88889 20.0001H9.33333C9.82425 20.0001 10.2222 19.6021 10.2222 19.1112V14.6667C10.2222 14.1758 9.82425 13.7778 9.33333 13.7778Z"
                    stroke={isActiveLink === 2 ? "#FFFFFF" : "#FFD705"}
                    // fill={isActiveLink === 2 ? "white" : "#FFD705"}
                    stroke-width="1.25"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M13.7773 4.88867H19.9996"
                    stroke={isActiveLink === 2 ? "#FFFFFF" : "#FFD705"}
                    // fill={isActiveLink === 2 ? "white" : "#FFD705"}
                    stroke-width="1.25"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M13.7773 9.3335H19.9996"
                    stroke={isActiveLink === 2 ? "#FFFFFF" : "#FFD705"}
                    // fill={isActiveLink === 2 ? "white" : "#FFD705"}
                    stroke-width="1.25"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M13.7773 14.6665H19.9996"
                    stroke={isActiveLink === 2 ? "#FFFFFF" : "#FFD705"}
                    // fill={isActiveLink === 2 ? "white" : "#FFD705"}
                    stroke-width="1.25"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M13.7773 19.1113H19.9996"
                    stroke={isActiveLink === 2 ? "#FFFFFF" : "#FFD705"}
                    // fill={isActiveLink === 2 ? "white" : "#FFD705"}
                    stroke-width="1.25"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                {isExpanded ? (
                  <div data-aos="fade-in" className="sidebar-title">
                    Booking View{" "}
                  </div>
                ) : null}
              </div>
            </NavLink>
          </div>
          <div className="col-md-12 height_fiz_menu">
            <NavLink
              to="/all-customer"
              isActive={(match) => {
                if (
                  match?.isExact ||
                  (location && location.pathname.includes("all-customer"))
                ) {
                  setIsActiveLink(3);
                }
              }}
            >
              <div
                className={`py-1 mb-3  ${
                  isActiveLink === 3 ? "inv_active_menu" : "inv_inactive_menu"
                } ${
                  isExpanded ? "ms-2 py-0 d-flex" : "ms-1 sidebar-item d-flex "
                }`}
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  // stroke={isActiveLink === 3 ? "white" : "#FFD705"}
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1.00174 15.9852C1.08008 15.6598 1.13173 15.325 1.24083 15.0107C1.67954 13.7472 2.5175 12.8525 3.73962 12.3295L3.90907 12.2545C3.06008 11.5755 2.67012 10.7096 2.84653 9.63427C2.8981 9.30647 3.01399 8.99238 3.18739 8.71046C3.36079 8.42854 3.5882 8.18448 3.85626 7.9926C4.38891 7.59946 5.05001 7.42659 5.70456 7.5093C6.3591 7.592 6.95771 7.92404 7.37813 8.43761C8.23291 9.49297 8.21783 11.1933 6.88777 12.2281L8.16038 12.951C8.81374 12.3886 9.57461 11.9679 10.3957 11.7151C8.28108 10.4803 8.06869 7.66192 9.59721 6.09002C11.0561 4.58906 13.4452 4.6477 14.8025 6.20728C16.1988 7.8167 15.9585 10.4551 13.8845 11.7139C14.7078 11.9676 15.4707 12.3897 16.1256 12.954L17.3977 12.2305C16.58 11.5691 16.1854 10.7002 16.374 9.61257C16.4901 8.9518 16.8301 8.41709 17.3605 8.01077C18.419 7.20108 19.9295 7.36583 20.8296 8.36256C21.642 9.26255 21.8863 11.0649 20.392 12.2562C20.4692 12.2914 20.5389 12.3225 20.6079 12.3547C22.1086 13.0478 22.9877 14.2177 23.2454 15.8644C23.2551 15.9059 23.2681 15.9464 23.2843 15.9858V16.5574C23.174 16.6301 23.0719 16.7427 22.9518 16.7667C22.7365 16.8095 22.6036 16.6225 22.585 16.3335C22.4922 14.7926 21.7697 13.6587 20.3735 13.0284C19.1612 12.482 17.971 12.618 16.8504 13.3403C16.8056 13.371 16.7624 13.4041 16.721 13.4394C17.053 13.987 17.4093 14.5036 17.6907 15.0582C18.0859 15.8374 18.2461 16.687 18.2635 17.5618C18.2687 17.8198 18.1399 17.9857 17.9339 17.9992C17.7279 18.0126 17.5805 17.8626 17.5694 17.5999C17.5079 16.1634 17.0141 14.9029 15.9956 13.8973C14.4352 12.3571 12.5614 11.8658 10.4897 12.5389C8.40062 13.2178 7.17096 14.7293 6.78331 16.9198C6.74269 17.1496 6.73457 17.3859 6.71368 17.6186C6.69163 17.8614 6.55177 18.0103 6.35215 17.9992C6.15252 17.988 6.01383 17.8233 6.01905 17.5653C6.04052 16.4982 6.29702 15.4927 6.83728 14.5751C7.0607 14.194 7.33228 13.841 7.59168 13.4611C7.07929 13.0594 6.46614 12.81 5.82117 12.7411C3.858 12.5277 2.14958 13.7965 1.76368 15.7477C1.7287 15.9273 1.70813 16.1095 1.70217 16.2924C1.69579 16.4935 1.67722 16.6782 1.45786 16.7585C1.23851 16.8389 1.12186 16.6999 1 16.5609L1.00174 15.9852ZM14.9871 8.58184C14.9864 8.01395 14.8191 7.45901 14.5065 6.98712C14.1938 6.51522 13.7497 6.14754 13.2303 5.93051C12.7109 5.71348 12.1395 5.65685 11.5882 5.76777C11.037 5.87869 10.5306 6.15218 10.1331 6.55369C9.73566 6.95521 9.46487 7.46673 9.35497 8.02366C9.24508 8.58059 9.30102 9.15792 9.51571 9.68275C9.73041 10.2076 10.0942 10.6563 10.5612 10.9724C11.0282 11.2884 11.5775 11.4575 12.1395 11.4583C12.8946 11.4583 13.6188 11.1552 14.1528 10.6158C14.6868 10.0764 14.9869 9.34477 14.9871 8.58184ZM5.36679 11.9983C5.7379 12.0005 6.10138 11.8918 6.4115 11.6859C6.72161 11.4799 6.96451 11.1859 7.10963 10.8408C7.25475 10.4957 7.29561 10.1149 7.22706 9.74641C7.15852 9.3779 6.98363 9.03811 6.72441 8.76978C6.46519 8.50145 6.13321 8.31658 5.77025 8.23842C5.40728 8.16026 5.02954 8.19231 4.68456 8.33053C4.33958 8.46875 4.04277 8.70697 3.83146 9.01522C3.62016 9.32346 3.50381 9.68796 3.49705 10.0629C3.49259 10.3144 3.53757 10.5643 3.62939 10.7981C3.7212 11.0319 3.85803 11.245 4.03193 11.425C4.20584 11.605 4.41337 11.7484 4.64251 11.8468C4.87164 11.9452 5.11782 11.9967 5.36679 11.9983ZM18.9007 11.9924C19.2717 11.992 19.6344 11.8808 19.943 11.6726C20.2516 11.4645 20.4924 11.1688 20.635 10.8227C20.7777 10.4766 20.8158 10.0956 20.7446 9.72765C20.6735 9.35971 20.4961 9.02127 20.235 8.75491C19.9739 8.48856 19.6406 8.3062 19.2771 8.23079C18.9137 8.15537 18.5362 8.19027 18.1923 8.3311C17.8484 8.47192 17.5535 8.71238 17.3445 9.0222C17.1356 9.33202 17.022 9.69736 17.0181 10.0722C17.0158 10.3235 17.0627 10.5728 17.1562 10.8057C17.2498 11.0385 17.3881 11.2504 17.5631 11.4289C17.7382 11.6075 17.9465 11.7492 18.1761 11.8459C18.4056 11.9426 18.6519 11.9924 18.9007 11.9924Z"
                    fill="#FFD705"
                    stroke={isActiveLink === 3 ? "white" : "#FFD705"}
                    stroke-width="1"
                  />
                </svg>
                {isExpanded ? (
                  <div data-aos="fade-in" className="sidebar-title">
                    Customers{" "}
                  </div>
                ) : null}
              </div>
            </NavLink>
          </div>
          <div className="col-md-12 height_fiz_menu">
            <NavLink
              to="/staff-list"
              isActive={(match) => {
                if (
                  match?.isExact ||
                  (location &&
                    (location.pathname.includes("staff-list") ||
                      location.pathname.includes("add-staff")))
                ) {
                  setIsActiveLink(4);
                }
              }}
            >
              <div
                className={`py-1 mb-3  ${
                  isActiveLink === 4 ? "inv_active_menu" : "inv_inactive_menu"
                } ${
                  isExpanded ? "ms-2 py-0 d-flex" : "ms-1 sidebar-item d-flex "
                }`}
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11.238 16.5953C10.8622 16.8606 10.4814 17.1259 10.1055 17.3974C9.94272 17.5147 9.77997 17.6167 9.58159 17.4926C9.3832 17.3685 9.39733 17.1855 9.42251 16.9835C9.50973 16.2919 9.58404 15.5991 9.66143 14.9069C9.66818 14.8455 9.66143 14.7841 9.66143 14.6913C9.29968 14.8105 8.94652 14.9051 8.60995 15.0414C7.59778 15.4523 6.58684 15.8687 5.58511 16.3042C4.86836 16.6156 4.46792 17.1831 4.27814 17.9422C3.97903 19.1429 3.81197 20.3614 3.69098 21.5886C3.68484 21.65 3.68668 21.7114 3.67624 21.7728C3.63877 21.9921 3.48093 22.1291 3.28501 22.1162C3.07741 22.102 2.93185 21.9405 2.95089 21.7034C2.98836 21.2305 3.03381 20.7576 3.09461 20.2865C3.21745 19.3223 3.38819 18.3678 3.6744 17.4337C3.89796 16.704 4.33403 16.1783 4.99058 15.7987C6.26562 15.0617 7.64446 14.5826 9.03189 14.1201C9.11911 14.0913 9.20571 14.0587 9.29353 14.0342C9.80023 13.8745 9.79655 13.8739 9.8463 13.3395C9.87455 13.0423 9.99554 12.7253 9.92798 12.4557C9.86349 12.1959 9.57974 11.9988 9.44585 11.7457C9.22229 11.3219 9.04418 10.8742 8.83904 10.44C8.7903 10.3181 8.71762 10.2072 8.62531 10.1138C7.9927 9.57153 7.75378 8.89777 7.90119 8.07907C7.92107 7.95968 7.91689 7.83752 7.8889 7.71977C7.42028 5.70342 8.28996 3.5372 10.0306 2.50354C10.9696 1.94525 12.0217 1.82671 13.0947 1.90594C13.7912 1.9571 14.4722 2.13703 15.1031 2.43659C15.5864 2.66445 16.1023 2.70806 16.6305 2.66384C17.1452 2.62084 17.3897 2.90214 17.2318 3.39717C17.1378 3.69075 16.961 3.9573 16.8326 4.24105C16.7898 4.32249 16.7758 4.41596 16.7927 4.50638C17.1273 5.49899 17.1938 6.56237 16.9855 7.58895C16.9678 7.69171 16.976 7.79728 17.0095 7.89604C17.1428 8.27463 17.1583 8.68473 17.0539 9.07231C16.9495 9.45988 16.7302 9.80673 16.4248 10.0672C16.3266 10.1577 16.2548 10.2732 16.2172 10.4013C16.0187 11.1042 15.6579 11.7507 15.1639 12.2887C15.0905 12.3778 15.0525 12.4908 15.057 12.6062C15.0816 12.9569 15.154 13.3051 15.17 13.6558C15.1786 13.8511 15.2646 13.9101 15.4274 13.9629C16.7349 14.3744 18.0253 14.8308 19.2543 15.4443C19.5614 15.5985 19.8556 15.7803 20.1565 15.9467C20.8893 16.3521 21.2393 17.0191 21.4377 17.796C21.7614 19.0625 21.9125 20.3535 21.9985 21.6537C22.0169 21.9325 21.8879 22.0996 21.668 22.1155C21.4482 22.1315 21.2854 21.9657 21.2651 21.6856C21.1855 20.4707 21.016 19.2634 20.7578 18.0736C20.5852 17.3028 20.1787 16.7544 19.4785 16.3828C18.1605 15.682 16.7693 15.1729 15.3567 14.7134C15.3296 14.7105 15.3022 14.7105 15.275 14.7134C15.3125 15.0691 15.3475 15.421 15.3874 15.7729C15.4372 16.2145 15.5072 16.6543 15.5336 17.0965C15.5282 17.2432 15.4676 17.3824 15.3641 17.4865C15.2456 17.605 15.0779 17.5614 14.9415 17.465C14.597 17.2193 14.2543 16.9736 13.9103 16.7335C13.844 16.6868 13.7746 16.6438 13.7261 16.6106C13.6604 16.8268 13.5891 17.0301 13.5418 17.239C13.5283 17.3289 13.5316 17.4205 13.5516 17.5092C13.7359 18.6878 13.9294 19.8658 14.1099 21.045C14.1361 21.2581 14.1435 21.4731 14.132 21.6875C14.1315 21.7842 14.0925 21.8768 14.0237 21.9448C13.9549 22.0128 13.8618 22.0507 13.7651 22.0501C13.6683 22.0496 13.5758 22.0106 13.5077 21.9418C13.4397 21.8729 13.4018 21.7799 13.4024 21.6832C13.3692 20.2355 13.0499 18.8297 12.7882 17.4152C12.7673 17.301 12.7551 17.1524 12.8103 17.0639C12.9946 16.7636 12.9405 16.4399 12.9332 16.1242C12.9283 15.9203 12.7428 15.9074 12.5874 15.9246C12.3872 15.9473 12.0801 15.8073 12.0346 16.1218C11.9935 16.4209 11.9579 16.7433 12.1384 17.0387C12.1968 17.1352 12.1912 17.2899 12.1722 17.4115C11.9818 18.6202 11.7797 19.8277 11.5875 21.0352C11.5668 21.2025 11.5578 21.3709 11.5605 21.5394C11.5556 21.8717 11.4346 22.0455 11.1969 22.0498C10.9512 22.0535 10.7952 21.8748 10.8284 21.5278C10.9107 20.6907 11.0077 19.8541 11.1244 19.0213C11.1981 18.4993 11.3234 17.9846 11.4118 17.4637C11.4297 17.3599 11.3934 17.2439 11.3707 17.1358C11.3308 16.962 11.2853 16.79 11.238 16.5953ZM14.9993 6.00989C13.3296 6.43849 11.5793 6.44355 9.9071 6.02463C9.88745 6.10571 9.87148 6.16405 9.85981 6.22301C9.69337 7.05769 9.33776 7.77996 8.67014 8.33887C8.62185 8.39404 8.59695 8.46586 8.60074 8.53909C8.59614 8.75498 8.64949 8.96816 8.75524 9.15643C8.86099 9.3447 9.01527 9.50119 9.20202 9.60961C9.28095 9.65465 9.349 9.71652 9.40133 9.79082C9.45366 9.86513 9.48899 9.95004 9.50481 10.0395C9.65529 10.7446 9.99984 11.3539 10.4746 11.8894C10.9494 12.425 11.5488 12.7346 12.2858 12.737C13.8557 12.7425 15.205 11.6389 15.541 10.0561C15.5575 9.9592 15.5932 9.86654 15.6459 9.78356C15.6986 9.70057 15.7674 9.62891 15.8481 9.57275C16.2166 9.30436 16.4008 8.93339 16.3898 8.55567C16.1957 8.40028 16.0348 8.31 15.9224 8.17611C15.555 7.74176 15.2894 7.23079 15.1448 6.68058C15.0883 6.46807 15.0496 6.25065 14.9993 6.00989ZM8.58293 7.366C8.93608 6.87466 9.12893 6.37103 9.16947 5.80844C9.20386 5.33798 9.45261 5.13837 9.88253 5.25568C11.5683 5.72019 13.3489 5.71488 15.0318 5.24033C15.455 5.12363 15.7203 5.32385 15.7394 5.76238C15.762 6.27677 15.9055 6.77859 16.1582 7.2272C16.1937 7.28116 16.2324 7.33286 16.2743 7.38197C16.4617 6.44098 16.3752 5.46598 16.025 4.57271C15.9187 4.29879 15.9494 4.07645 16.1693 3.86579C16.2878 3.75217 16.364 3.59432 16.4917 3.40884C15.8548 3.43156 15.3113 3.34005 14.8052 3.10666C13.8741 2.67674 12.9012 2.56434 11.8921 2.66077C9.37276 2.9003 8.21749 5.37115 8.58293 7.366ZM10.622 13.0005C10.5919 13.3266 10.5606 13.627 10.5415 13.9279C10.5415 13.9703 10.5974 14.0317 10.6429 14.0593C11.2116 14.4027 11.7816 14.7448 12.3577 15.0764C12.3958 15.0937 12.4372 15.1024 12.479 15.1019C12.5208 15.1013 12.562 15.0916 12.5997 15.0734C13.1819 14.7376 13.7597 14.3935 14.3329 14.0409C14.3664 14.0161 14.394 13.984 14.4135 13.9471C14.4331 13.9103 14.4441 13.8695 14.4459 13.8278C14.4299 13.5391 14.3906 13.2517 14.3575 12.9409C13.1236 13.5299 11.8983 13.7375 10.622 13.0005ZM10.415 14.7816C10.3536 15.3264 10.2922 15.8368 10.2308 16.3994C10.5188 16.1961 10.759 16.0106 11.0151 15.8515C11.219 15.725 11.3338 15.5678 11.3142 15.3123L10.415 14.7816ZM14.5362 14.7816L13.6063 15.3344C13.6505 15.467 13.6542 15.6292 13.7359 15.6955C14.035 15.9412 14.3599 16.1494 14.7186 16.4031C14.6553 15.8405 14.5976 15.3307 14.5362 14.7816Z"
                    fill="#FFD705"
                    stroke={isActiveLink === 4 ? "white" : "#FFD705"}
                    stroke-width="0.5"
                  />
                  <path
                    d="M7.32213 18.8065C7.85033 18.8065 8.37852 18.8065 8.90672 18.8065C9.31331 18.8065 9.52581 19.024 9.53011 19.4318C9.53011 19.6461 9.53503 19.8617 9.53011 20.0748C9.52029 20.4126 9.30225 20.6411 8.96629 20.6423C7.87223 20.6485 6.77797 20.6485 5.6835 20.6423C5.34754 20.6423 5.13074 20.412 5.11845 20.0754C5.1117 19.8537 5.11415 19.632 5.11845 19.4103C5.12398 19.0319 5.3414 18.8096 5.71728 18.8065C6.251 18.8035 6.78657 18.8065 7.32213 18.8065ZM8.78388 19.5583H5.86161V19.8986H8.78388V19.5583Z"
                    fill={isActiveLink === 4 ? "white" : "#FFD705"}
                  />
                  <path
                    d="M17.6293 20.8301C18.1501 20.8301 18.6734 20.8301 19.1924 20.8301C19.4829 20.8301 19.6512 20.9683 19.6506 21.1986C19.65 21.429 19.4817 21.5672 19.1924 21.5672C18.1499 21.5672 17.1075 21.5672 16.065 21.5672C15.7751 21.5672 15.6074 21.4283 15.6074 21.1986C15.6074 20.9689 15.7751 20.8301 16.0656 20.8301C16.5852 20.8289 17.1054 20.8301 17.6293 20.8301Z"
                    fill={isActiveLink === 4 ? "white" : "#FFD705"}
                  />
                </svg>
                {isExpanded ? (
                  <div data-aos="fade-in" className="sidebar-title">
                    Staff{" "}
                  </div>
                ) : null}
              </div>
            </NavLink>
          </div>
          <div className="col-md-12 height_fiz_menu">
            <NavLink
              to="/all-services"
              isActive={(match) => {
                if (
                  match?.isExact ||
                  (location &&
                    (location.pathname.includes("all-service") ||
                      location.pathname.includes("create-service")))
                ) {
                  setIsActiveLink(5);
                }
              }}
            >
              <div
                className={`py-1 mb-3  ${
                  isActiveLink === 5 ? "inv_active_menu" : "inv_inactive_menu"
                } ${
                  isExpanded ? "ms-2 py-0 d-flex" : "ms-1 sidebar-item d-flex "
                }`}
              >
                <SideBarServices isActiveLink={isActiveLink} />
                {isExpanded ? (
                  <div data-aos="fade-in" className="sidebar-title">
                    Services
                  </div>
                ) : null}
              </div>
            </NavLink>
          </div>
          <div className="col-md-12 height_fiz_menu">
            <NavLink
              to="/dynamic-services"
              isActive={(match) => {
                if (
                  match?.isExact ||
                  (location && location.pathname.includes("dynamic-services"))
                ) {
                  setIsActiveLink(101);
                }
              }}
            >
              <div
                className={`py-1 mb-3  ${
                  isActiveLink === 101 ? "inv_active_menu" : "inv_inactive_menu"
                } ${
                  isExpanded ? "ms-2 py-0 d-flex" : "ms-1 sidebar-item d-flex "
                }`}
              >
                <SideBarDynamicServices isActiveLink={isActiveLink} />

                {isExpanded ? (
                  <div data-aos="fade-in" className="sidebar-title">
                    Dynamic Services
                  </div>
                ) : null}
              </div>
            </NavLink>
          </div>
          {/* <div className="col-md-12 height_fiz_menu">
            <NavLink
              to="/maintenance"
              isActive={(match) => {
                if (
                  match?.isExact ||
                  (location &&
                    (location.pathname.includes("subscribe") ||
                      location.pathname.includes("add-subscription") ||
                      location.pathname.includes("business/calender")))
                ) {
                  setIsActiveLink(6);
                }
              }}
            >
              <div
                className={`py-1 mb-3  ${
                  isActiveLink === 6 ? "inv_active_menu" : "inv_inactive_menu"
                } ${
                  isExpanded ? "ms-2 py-0 d-flex" : "ms-1 sidebar-item d-flex "
                }`}
              >
                <SideBarProducts isActiveLink={isActiveLink}/>
                {isExpanded ? (
                  <div data-aos="fade-in" className="sidebar-title">
                    Products{" "}
                  </div>
                ) : null}
              </div>
            </NavLink>
          </div> */}
          <div className="col-md-12 height_fiz_menu">
            <NavLink
              to="/businesses"
              isActive={(match) => {
                if (
                  match?.isExact ||
                  (location && location.pathname.includes("businesses"))
                ) {
                  setIsActiveLink(105);
                }
              }}
            >
              <div
                className={`py-1 mb-3  ${
                  isActiveLink === 105 ? "inv_active_menu" : "inv_inactive_menu"
                } ${
                  isExpanded ? "ms-2 py-0 d-flex" : "ms-1 sidebar-item d-flex "
                }`}
              >
                <SideBarBusinesses isActiveLink={isActiveLink} />
                {isExpanded ? (
                  <div data-aos="fade-in" className="sidebar-title">
                    Businesses
                  </div>
                ) : null}
              </div>
            </NavLink>
          </div>
       
          {/* <div className="col-md-12 height_fiz_menu">
            <NavLink
              to="/maintenance"
              isActive={(match) => {
                if (
                  match?.isExact ||
                  (location &&
                    (location.pathname.includes("subscribe") ||
                      location.pathname.includes("add-subscription") ||
                      location.pathname.includes("business/calender")))
                ) {
                  setIsActiveLink(7);
                }
              }}
            >
              <div
                className={`py-1 mb-3  ${
                  isActiveLink === 7 ? "inv_active_menu" : "inv_inactive_menu"
                } ${
                  isExpanded ? "ms-2 py-0 d-flex" : "ms-1 sidebar-item d-flex "
                }`}
              >
                <SideBarWaitinglist isActiveLink={isActiveLink}/>
                {isExpanded ? (
                  <div data-aos="fade-in" className="sidebar-title">
                    Waiting List{" "}
                  </div>
                ) : null}
              </div>
            </NavLink>
          </div> */}
          {/* <div className="col-md-12 height_fiz_menu">
            <NavLink
              to="/maintenance"
              isActive={(match) => {
                if (
                  match?.isExact ||
                  (location && location.pathname.includes("maintenance"))
                ) {
                  setIsActiveLink(8);
                }
              }}
            >
              <div
                className={`py-1 mb-3  ${
                  isActiveLink === 8 ? "inv_active_menu" : "inv_inactive_menu"
                } ${
                  isExpanded ? "ms-2 py-0 d-flex" : "ms-1 sidebar-item d-flex "
                }`}
              >
                <SideBarFinancials isActiveLink={isActiveLink}/>
                {isExpanded ? (
                  <div data-aos="fade-in" className="sidebar-title">
                    Financials{" "}
                  </div>
                ) : null}
              </div>
            </NavLink>
          </div> */}
          {/* <div className="col-md-12 height_fiz_menu">
            <NavLink
              to="/maintenance"
              isActive={(match) => {
                if (
                  match?.isExact ||
                  (location && location.pathname.includes("maintenance"))
                ) {
                  setIsActiveLink(9);
                }
              }}
            >
              <div
                className={`py-1 mb-3  ${
                  isActiveLink === 9 ? "inv_active_menu" : "inv_inactive_menu"
                } ${
                  isExpanded ? "ms-2 py-0 d-flex" : "ms-1 sidebar-item d-flex "
                }`}
              >
                <SideBarAnalytics isActiveLink={isActiveLink}/>
                {isExpanded ? (
                  <div data-aos="fade-in" className="sidebar-title">
                    Analytics{" "}
                  </div>
                ) : null}
              </div>
            </NavLink>
          </div> */}
          {/* <div className="col-md-12 height_fiz_menu">
            <NavLink
              to="/maintenance"
              isActive={(match) => {
                if (
                  match?.isExact ||
                  (location && location.pathname.includes("maintenance"))
                ) {
                  setIsActiveLink(10);
                }
              }}
            >
              <div
                className={`py-1 mb-3  ${
                  isActiveLink === 10 ? "inv_active_menu" : "inv_inactive_menu"
                } ${
                  isExpanded ? "ms-2 py-0 d-flex" : "ms-1 sidebar-item d-flex "
                }`}
              >
                <SideBarMarketing isActiveLink={isActiveLink}/>
                {isExpanded ? (
                  <div data-aos="fade-in" className="sidebar-title">
                    Marketing
                  </div>
                ) : null}
              </div>
            </NavLink>
          </div> */}
          <hr
            className="mt-3 ms-2"
            style={{
              background: "#edf0f5",
              width: isExpanded ? "200px" : "10px",
              height: "1px",
              paddingLeft: "18px",
              paddingRight: isExpanded ? "18px" : "0px",
            }}
          ></hr>
          <div className="col-md-12 height_fiz_menu">
            <NavLink
              to="/Profile"
              isActive={(match) => {
                if (
                  match?.isExact ||
                  (location &&
                    (location.pathname.includes("Profile") ||
                      location.pathname.includes("edit-user-name") ||
                      location.pathname.includes("allemailsuser") ||
                      location.pathname.includes("show-all-numbers-of-users") ||
                      location.pathname.includes("addgenderuser") ||
                      location.pathname.includes("add-dob-user")))
                ) {
                  setIsActiveLink(11);
                }
              }}
            >
              <div
                className={`py-1 mb-3  ${
                  isActiveLink === 11 ? "inv_active_menu" : "inv_inactive_menu"
                } ${
                  isExpanded ? "ms-2 py-0 d-flex" : "ms-1 sidebar-item d-flex "
                }`}
              >
                <SideBarProfile isActiveLink={isActiveLink} />
                {isExpanded ? (
                  <div data-aos="fade-in" className="sidebar-title">
                    Profile{" "}
                  </div>
                ) : null}
              </div>
            </NavLink>
          </div>

          <div className="col-md-12 height_fiz_menu"></div>
        </div>
        <div
          className="ps-3 side_nav_1_right hide_scrollbar"
          style={{
            marginTop:
              extractedPart === "calendar" || extractedPart === "addScheduler"
                ? "-63px"
                : "0",
            marginLeft:
              extractedPart === "calendar" || extractedPart === "addScheduler"
                ? "10px"
                : "0",
            height: location.pathname.includes("/scheduler/create_booking")
              ? "87.5vh"
              : location.pathname.includes("/scheduler/booking_details/")
              ? "100vh"
              : "96vh",
          }}
        >
          <div className="col-md-12 background_sidenav_one ">{children}</div>
        </div>
      </div>
    </div>
  );
};

export default SideBarItem;
